import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import CardDetail from "components/CardDetail";
import CardImage from "components/CardImage";
import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import LoadingSpin from "components/Loading";
import ScrollUpBtn from "components/ScrollUpBtn";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  NameCourse,
  SubDetail,
  SubHead,
  SubTitle,
  TextBold,
  TextName,
  TextNote,
  Title,
  TitleEN,
  View,
} from "./science.style";

import downloadIcon from "assets/images/svg/icon-file-download.svg";

import learnIcon1 from "assets/images/svg/H09-1.svg";
import learnIcon2 from "assets/images/svg/H09-2.svg";

import stuView from "assets/images/png/student_comp-01.png";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

const ScienceDepartment = ({ selectYear, year }) => {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`,
      { incrementVisitor: true }
    );
    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <p className="link-web" style={{ marginBottom: "0" }}>
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </p>
    );
  };

  const spliteLinkPhone = (link, text) => {
    const newLink = link.split(text);
    return (
      <p className="link-web" style={{ marginBottom: "0" }}>
        {newLink[0]}
        <a href={`http://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </p>
    );
  };

  const renderBtn = (link, text) => {
    return (
      <div className="btn-readding">
        <a href={link} target="_blank" rel="noreferrer">
          <p>{text}</p>
        </a>
      </div>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} />
        </div>
        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>

            {windowWidth <= 1280
              ? departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ maxWidth: "104px", width: "100%" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      <div className="col-image-profile">
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.message?.image &&
                              departmentData?.message?.image[0]?.image_0
                            }
                            alt="dean"
                            style={{ marginTop: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      </div>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                            
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            ></Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )
              : departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={2}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ width: "104px" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                            {/* <DetailTop>นี่คือหัวข้อที่คุณต้องการใส่ตรงๆ--------------------------------------------------------</DetailTop> */}
                            <DetailTop><p style={{ textIndent: '2em', marginBottom: '1em' }}>สวัสดีครับนักศึกษาทุกคน ในนามของสำนักวิชาวิทยาศาสตร์ ขอต้อนรับพวกเราเข้าสู่รั้วแสดทอง (ปีบทองช่อที่ 34) มทส. ซึ่งเป็นมหาวิทยาลัยที่ติดอันดับหนึ่งในสิบของประเทศจาก World University Ranking Times Higher Education (THE)  ในสาขาทางด้าน Physical Science ถูกจัดให้เป็นระดับแนวหน้า และสำนักวิชาวิทยาศาสตร์ยังคงพัฒนาไปข้างหน้าอย่างต่อเนื่อง ที่ มทส. พวกเราจะได้เรียนรู้จากคณาจารย์ผู้มีประสบการณ์พร้อมด้วยฝึกฝนทักษะต่าง ๆ ด้วยเครื่องมือวิทยาศาสตร์และเทคโนโลยีที่ทันสมัยรองรับทั้งการเรียนการสอนและการวิจัยอย่างเต็มรูปแบบ นอกจากนี้ นักศึกษายังมีโอกาสเข้าร่วมทำวิจัยหรือร่วมงานวิชาการในต่างประเทศได้ตั้งแต่ระดับปริญญาตรี และหลักสูตรยังเปิดโอกาสให้พัฒนาความรู้ด้านผู้ประกอบการและทักษะการบริหารควบคู่ไปกับศาสตร์ทางวิทยาศาสตร์ เพื่อเสริมสร้างภาวะผู้นำและความเข้าใจระบบต่าง ๆ อย่างรอบด้าน อีกทั้ง มทส. ยังเป็นมหาวิทยาลัยสีเขียวที่มีสภาพแวดล้อมดี อากาศบริสุทธิ์ พร้อมด้วยสถานที่ออกกำลังกายและโรงพยาบาลที่คอยดูแลสุขภาพของนักศึกษาอย่างใกล้ชิด</p> 
<p style={{ textIndent: '2em', marginBottom: '0em' }}>ในท้ายที่สุดนี้ ผมหวังเป็นอย่างยิ่งว่า นักศึกษาจะสามารถค้นพบความสนใจของตนเอง สนุกกับการเรียน พัฒนาทักษะที่จำเป็น และสำเร็จการศึกษาอย่างภาคภูมิใจนะครับ</p>
</DetailTop>
                             
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            >
                              <FadeInSection axis="y">
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="dean"
                                  width={"100%"}
                                />
                              </FadeInSection>
                            </Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )}

            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      หลักสูตรระดับปริญญาตรีในสำนักวิชาวิทยาศาสตร์
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <Href
                            to={item?.slang}
                            rel="noopener noreferrer"
                            target={"_self"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                            item?.text_0 ===
                              "เรียนพยาบาล มทส. อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                            item?.text_1 ===
                              "เรียนแพทย์อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.study && (
              <>
                <Element name={departmentData?.study?.title}>
                  <FixBox bg={ListColor2[slang]}>
                    <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                    {departmentData?.study?.sub_title && (
                      <SubDetail indent="32">
                        {departmentData?.study?.sub_title}
                      </SubDetail>
                    )}
                    <Row
                      gutter={24}
                      className="row-detail-card"
                      justify="center"
                    >
                      {departmentData?.study?.data &&
                        departmentData?.study?.data.map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <CardDetail
                                src={item?.image}
                                detail={item?.detail}
                              />
                            </Col>
                          );
                        })}
                    </Row>
                  </FixBox>
                </Element>
              </>
            )}

            {departmentData?.teacher && (
              <Element name={departmentData?.teacher?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                    {departmentData?.teacher?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail indent="32" bottom="0">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail indent="32" top="0" bottom="0">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail indent="32" top="0" bottom="0">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail indent="32" top="0">
                              {item?.text_3}
                            </SubDetail>
                          )}

                          {item?.text_4 && (
                            <SubHead bottom={"32"}>{item?.text_4}</SubHead>
                          )}

                          {
                            <>
                              {item?.text_5 && (
                                <SubDetail top="0" bottom="0" indent="32">
                                  {spliteLink(
                                    item?.text_5,
                                    "1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ "
                                  )}
                                </SubDetail>
                              )}
                              {item?.text_6 && (
                                <SubDetail top="0" bottom="0" indent="32">
                                  {spliteLinkPhone(
                                    item?.text_6,
                                    "2) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์ หรือสาขาวิชาที่อาจารย์สังกัด ได้ที่ "
                                  )}
                                </SubDetail>
                              )}
                              {item?.text_7 && (
                                <SubDetail top="0" indent="32">
                                  {item?.text_7}
                                </SubDetail>
                              )}
                            </>
                          }
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.teacher?.image &&
                      departmentData?.teacher?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.teacher_1 && (
              <Row gutter={24} className="row-group">
                <Col span={24}>
                  {departmentData?.teacher_1?.text.map((item) => {
                    return (
                      <>
                        {item?.text_0 && (
                          <SubHead top="20" bottom="20">
                            {item?.text_0}
                          </SubHead>
                        )}
                        {item?.text_1 && (
                          <SubDetail
                            className="link-web science"
                            indent="32"
                            top="0"
                            bottom="0"
                          >
                            1) ตรวจสอบตารางสอนของอาจารย์ที่ปรึกษา ผ่านระบบ{" "}
                            <a
                              href={`https://reg.sut.ac.th/`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <u>reg.sut.ac.th</u>
                            </a>
                          </SubDetail>
                        )}
                        {item?.text_2 && (
                          <SubDetail
                            className="link-web science"
                            indent="32"
                            top="0"
                            bottom="0"
                          >
                            2) นักศึกษาสามารถ E-mail หาอาจารย์ได้โดยตรงเพื่อขอพบ{" "}
                            <a
                              href={`https://www.sut.ac.th/phone/show_dept.php?id=1010000`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <u>ดูข้อมูลติดต่อบุคลากรในสำนักวิชาวิทยาศาสตร์</u>
                            </a>
                          </SubDetail>
                        )}
                        {item?.text_3 && (
                          <SubDetail
                            className="link-web science"
                            indent="32"
                            top="0"
                          >
                            3) ค้นหาเบอร์โทรศัพท์ E-mail ของอาจารย์
                            หรือสาขาวิชาที่อาจารย์สังกัด
                            <a
                              href={`https://www.sut.ac.th/2012/phone/`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <u>ดูข้อมูลติดต่อของบุคลากร</u>
                            </a>
                          </SubDetail>
                        )}
                      </>
                    );
                  })}
                </Col>
              </Row>
            )}

            {departmentData?.plane && (
              <Element name={departmentData?.plane?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="50">{departmentData?.plane?.title}</SubTitle>
                  {departmentData?.plane?.text.map((item, index) => {
                    return (
                      <>
                        <SubDetail>{item?.text_0}</SubDetail>

                        <Row gutter={24} className="row-detail-card">
                          {!item?.text_5 ? (
                            <>
                              <Col span={8}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_0
                                    }
                                    text={item?.text_1}
                                  />
                                </FadeInSection>
                              </Col>
                              <Col span={8}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_1
                                    }
                                    text={item?.text_2}
                                  />
                                </FadeInSection>
                              </Col>
                              <Col span={8}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_2
                                    }
                                    text={item?.text_3}
                                  />
                                </FadeInSection>
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col span={6}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_0
                                    }
                                    text={item?.text_1}
                                  />
                                </FadeInSection>
                              </Col>
                              <Col span={6}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_1
                                    }
                                    text={item?.text_2}
                                  />
                                </FadeInSection>
                              </Col>
                              <Col span={6}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_2
                                    }
                                    text={item?.text_3}
                                  />
                                </FadeInSection>
                              </Col>
                              <Col span={6}>
                                <FadeInSection axis="y">
                                  <CardImage
                                    src={
                                      departmentData?.plane?.image &&
                                      departmentData?.plane?.image[0].image_3
                                        ? departmentData?.plane?.image[0]
                                            .image_3
                                        : departmentData?.plane?.image[0]
                                            .image_2
                                    }
                                    text={item?.text_5}
                                  />
                                </FadeInSection>
                              </Col>
                            </>
                          )}
                        </Row>

                        <TextNote>{item?.text_4}</TextNote>
                      </>
                    );
                  })}
                </FixBox>
              </Element>
            )}

            {departmentData?.result && (
              <Element name={departmentData?.result?.title}>
                <FixBox bg={""}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_0 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_1 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_2 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                        </CustomCarousel>
                      </FadeInSection>
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.result?.title}</SubTitle>
                      <TextBold
                        className="bg-circle"
                        bottom="0"
                        indent="32"
                        style={{ display: "block" }}
                      >
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        เกรดเฉลี่ยเกรดเฉลี่ยสะสม 3.50 ขึ้นไป ไม่มี U และ F
                        ไม่เรียนซ้ำเพื่อปรับเกรด D D+
                        <span> จะได้รับ</span>
                      </TextBold>

                      {departmentData?.result?.text[0]?.text_1 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_1 &&
                            departmentData?.result?.text[0]?.text_1}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_2 && (
                        <TextBold
                          indent="32"
                          bottom="0"
                          style={{ display: "block" }}
                        >
                          หากได้รับปริญญาเกียรตินิยมอันดับหนึ่ง
                          พร้อมทั้งมีแต้มเฉลี่ยสูงสุดในสาขา
                          <span> จะได้รับ</span>
                        </TextBold>
                      )}

                      {departmentData?.result?.text[0]?.text_3 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_3}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_4 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_4}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_5 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_6 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_6}
                        </SubDetail>
                      )}

                      <TextBold
                        indent="32"
                        bottom="0"
                        className="bg-circle"
                        style={{ display: "block" }}
                      >
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        เกรดเฉลี่ยสะสม 3.25 ขึ้นไป ไม่มี U และ F
                        ไม่เรียนซ้ำเพื่อปรับเกรด D D+
                        <span> จะได้รับ</span>
                      </TextBold>

                      {departmentData?.result?.text[0]?.text_8 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_8}
                        </SubDetail>
                      )}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.estimate && (
              <Element name={departmentData?.estimate?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      <SubTitle>{departmentData?.estimate?.title}</SubTitle>
                      <SubDetail bottom={"32"} indent={"0"}>
                        {departmentData?.estimate?.text[0].text_0}
                      </SubDetail>

                      {departmentData?.estimate?.text[0].text_1 && (
                        <SubHead>
                          {departmentData?.estimate?.text[0].text_1}
                        </SubHead>
                      )}

                      {departmentData?.estimate?.text[0].text_2 && (
                        <SubDetail bottom={"0"} top="0" indent="32">
                          {spliteLink(
                            departmentData?.estimate?.text[0].text_2,
                            "1) Log in : "
                          )}
                        </SubDetail>
                      )}

                      {departmentData?.estimate?.text[0].text_3 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.estimate?.text[0].text_3}
                        </SubDetail>
                      )}

                      {departmentData?.estimate?.text[0].text_4 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.estimate?.text[0].text_4}
                        </SubDetail>
                      )}

                      {departmentData?.estimate?.text[0].text_5 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.estimate?.text[0].text_5}
                        </SubDetail>
                      )}
                      {departmentData?.estimate?.text[0].text_6 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.estimate?.text[0].text_6}
                        </SubDetail>
                      )}
                      {departmentData?.estimate?.text[0].text_7 && (
                        <SubDetail top="0" indent="32">
                          {departmentData?.estimate?.text[0].text_7}
                        </SubDetail>
                      )}
                    </Col>
                    <Col
                      span={11}
                      offset={1}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.estimate?.image &&
                              departmentData?.estimate?.image[0]?.image_0
                                ? departmentData?.estimate?.image[0]?.image_0
                                : engineer1
                            }
                            alt="icon rectangle"
                            style={{ borderRadius: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      }
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.project && (
              <Element name={departmentData?.project?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.project?.title}</SubTitle>
                    <SubDetail>
                      {departmentData?.project?.text[0]?.text_0}
                    </SubDetail>
                    <SubHead>
                      <a
                        href="https://beta.sut.ac.th/dsa/งานกิจกรรมนักศึกษา/แบบฟอร์มงานกิจกรรมนักศ"
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <img
                          src={downloadIcon}
                          alt="icon download file"
                          loading="lazy"
                        />
                        ดาวน์โหลดแบบฟอร์ม
                      </a>
                    </SubHead>
                    {departmentData?.project?.text[0]?.text_1 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_2 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_2}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_3 && (
                      <TextNote>
                        {departmentData?.project?.text[0]?.text_3}
                      </TextNote>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {departmentData.project?.image &&
                    departmentData.project.image[0]?.image_0 &&
                    !departmentData.project.image[0]?.image_1 ? (
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={departmentData.project.image[0]?.image_0}
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        />
                      </FadeInSection>
                    ) : (
                      departmentData.project.image.map((item) => {
                        return (
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item.image_0 && (
                              <img
                                loading="lazy"
                                src={item.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_1 && (
                              <img
                                loading="lazy"
                                src={item.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_2 && (
                              <img
                                loading="lazy"
                                src={item.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.final && (
              <Element name={departmentData?.final?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col
                      span={11}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.final?.image
                              ? departmentData?.final?.image[0]?.image_0
                              : maindataSci
                          }
                          alt="icon rectangle"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      </FadeInSection>
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.final?.title}</SubTitle>
                      <SubDetail indent="32">
                        {departmentData?.final?.text[0]?.text_0}
                      </SubDetail>
                      {departmentData?.final?.text[0]?.text_1 && (
                        <SubDetail bottom="0" indent="32">
                          {departmentData?.final?.text[0]?.text_1}
                        </SubDetail>
                      )}
                      {departmentData?.final?.text[0]?.text_2 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.final?.text[0]?.text_2}
                        </SubDetail>
                      )}
                      {departmentData?.final?.text[0]?.text_3 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.final?.text[0]?.text_3}
                        </SubDetail>
                      )}
                      {departmentData?.final?.text[0]?.text_4 && (
                        <SubDetail bottom="0" top="0" indent="32">
                          {departmentData?.final?.text[0]?.text_4}
                        </SubDetail>
                      )}
                      {departmentData?.final?.text[0]?.text_5 && (
                        <SubDetail top="0" indent="32">
                          {departmentData?.final?.text[0]?.text_5}
                        </SubDetail>
                      )}
                      {departmentData?.final?.text[0]?.text_6 && (
                        <TextNote>
                          {departmentData?.final?.text[0]?.text_6}
                        </TextNote>
                      )}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.activity && (
              <Element name={departmentData?.activity?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.activity?.title}</SubTitle>
                    {departmentData?.activity?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0" indent="35">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_3}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" indent="35">
                              {item?.text_6}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                  <Col span={12} offset={1}>
                    {departmentData?.activity?.image &&
                      departmentData?.activity?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_3 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_3}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.register &&
              departmentData?.grade &&
              departmentData?.news &&
              departmentData?.news_1 && (
                <Element name={departmentData.register?.title}>
                  <Element name={departmentData.grade?.title}>
                    <Element name={departmentData.news?.title}>
                      <Element name={departmentData.news_1?.title}>
                        <FixBox bg={ListColor2[slang]}>
                          <Row gutter={24} className="row-group">
                            <Col span={11}>
                              <SubTitle bottom="0">
                                {departmentData?.register?.title}
                              </SubTitle>
                              <SubDetail top="0">
                                และขั้นตอนต่าง ๆ ที่จำเป็นต้องรู้
                              </SubDetail>
                              {renderBtn(
                                "http://bulletin.sut.ac.th/enrollment",
                                "อ่านต่อ"
                              )}
                            </Col>
                            <Col span={12} offset={1}>
                              <SubTitle bottom="0">
                                {departmentData?.grade?.title}
                              </SubTitle>
                              <SubDetail top="0">และตัวอย่าง</SubDetail>
                              {renderBtn(
                                "http://bulletin.sut.ac.th/enrollment/calculate-grade",
                                "อ่านต่อ"
                              )}
                            </Col>
                          </Row>
                          <Row gutter={24} className="row-group">
                            <Col span={11}>
                              <SubTitle bottom="0">
                                {departmentData?.news?.title}
                              </SubTitle>
                              <SubDetail top="0">
                                ช่องทางติดตามข่าวสารและกิจกรรมต่าง ๆ
                                จากคณะประสานงานวิทยาศาสตร์ มทส.
                              </SubDetail>
                              {renderBtn(
                                "https://web.facebook.com/sciencesutstudents",
                                "ติดตามเฟซบุ๊ก"
                              )}
                            </Col>
                            <Col span={12} offset={1}>
                              <SubTitle bottom="0">
                                {departmentData?.news_1?.title}
                              </SubTitle>
                              <SubDetail top="0">
                                ช่องทางติดตามข่าวประชาสัมพันธ์/กิจกรรม/ทุน
                                จากสำนักวิชาวิทยาศาสตร์
                              </SubDetail>
                              {renderBtn(
                                "https://science-sut.notion.site/a1cf60801656475dbd280aa657b568dc?pvs=4",
                                "อ่านต่อ"
                              )}
                            </Col>
                          </Row>
                        </FixBox>
                      </Element>
                    </Element>
                  </Element>
                </Element>
              )}

            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"var(--black)"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                            return (
                              <Col
                                span={12}
                                style={{ padding: "10px" }}
                                key={index}
                              >
                                <div style={styleDetailContact}>
                                  <DetailContact
                                    color="var(--black)"
                                    title={item?.title}
                                    phone={item?.phone_1}
                                    office={item?.phone_2}
                                    facebook={item?.fb}
                                    website={item?.site}
                                    email1={item?.email_1}
                                    email2={item?.email_2}
                                    email3={item?.email_3}
                                    line={item?.line}
                                    indent={"40"}
                                    slang={slang}
                                    type="branch"
                                  />
                                </div>
                              </Col>
                            );
                          })
                        : contactData[0]?.address !== "" && (
                            <Col span={12} style={{ padding: "10px" }}>
                              <DetailContact
                                color="var(--black)"
                                title={contactData[0]?.title}
                                address={contactData[0]?.address}
                                slang={slang}
                                type="branch"
                              />
                            </Col>
                          )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}

            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>ตั้งแต่เริ่มเปิดเว็บไซต์</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>ปี (พ.ศ.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
};

export default ScienceDepartment;
